module.exports = __webpack_public_path__ + "static/media/guide_step_3.22a7e052.png";